import { AIAgentSuggestion } from './AIAgentTypes';

export const AI_AGENT_PANEL_WIDTH_NORMAL = 440;
export const AI_AGENT_PANEL_WIDTH_EXPANDED = 774;
export const AI_AGENT_HEADER_HEIGHT = 64;

export const AI_AGENT_WELCOME_MESSAGE = 'Como posso ajudar na sua operação?';
export const AI_AGENT_WELCOME_SUBTITLE =
  'Pergunte sobre indicadores, alarmes, usinas, desempenho, navegação ou comandos.';
export const AI_AGENT_SUGGESTIONS_LABEL = 'Sugestões rápidas';
export const AI_AGENT_ASSISTANT_NAME = 'Assistente SGD';
export const AI_AGENT_LAUNCHER_TOOLTIP = 'Pergunte ao Assistente SGD';
export const AI_AGENT_COMPOSER_PLACEHOLDER = 'Pergunte ao Assistente SGD';
export const AI_AGENT_DISCLAIMER = 'Ações críticas exigem confirmação humana';
export const AI_AGENT_THINKING_LABEL = 'Pensando...';
export const AI_AGENT_THINKING_HINT = 'Analisando dados do sistema';

export const AI_AGENT_SUGGESTIONS: AIAgentSuggestion[] = [
  { id: 'suggestion-plants-today', text: 'Como estão minhas usinas hoje?' },
  { id: 'suggestion-top-five', text: 'Minhas 5 melhores usinas?' },
  { id: 'suggestion-bottom-five', text: 'Minhas 5 piores usinas?' },
];

/**
 * Tokens locais alinhados ao Figma do Agente IA (nó 7015:3491).
 * Exceção deliberada ao DS/`ati-ui-library` enquanto o tema não cobre esse painel;
 * preferir mapear para tokens do tema quando existirem equivalentes oficiais.
 */
export const AI_AGENT_TOKENS = {
  primary: '#2d5de7',
  white: '#ffffff',
  surface: '#f5f6fa',
  textPrimary: 'rgba(0, 0, 0, 0.87)',
  textSecondary: 'rgba(0, 0, 0, 0.6)',
  textDisabled: 'rgba(0, 0, 0, 0.38)',
  textNeutral: '#47484c',
  textBody: '#1a2540',
  border: 'rgba(0, 0, 0, 0.23)',
  borderSubtle: 'rgba(0, 0, 0, 0.08)',
  blueGrey100: '#cfd8dc',
  headerIconBg: 'rgba(255, 255, 255, 0.2)',
  sendAdornmentBg: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 8,
  fontFamily: "'Work Sans', sans-serif",
  fontFamilyDisplay: "'Borna', 'Work Sans', sans-serif",
};
